import request from "@/utils/request";

// 登录
export function login(data) {
    return request({
        url: "/pc/online/login",
        method: "post",
        data,
    });
}

// 获取验证码/pc/online/captchaImage
export function getCaptchaImage() {
    return request({
        url: "/pc/online/captchaImage",
        method: "get",
    });
}
// 注册/pc/online/addStudent
export function register(data) {
    return request({
        url: "/pc/online/addStudent",
        method: "post",
        data,
    });
}

// /pc/online/getAreaList获取省份
export function getAreaList(params = {}) {
    return request({
        url: "/pc/online/getAreaList",
        method: "get",
        params
    });
}

// 根据省份获取学校/pc/online/getSysDeptList
export function getSysDeptList(data) {
    return request({
        url: "/pc/online/getSysDeptList",
        method: "get",
        params: data,
    });
}

// /pc/check/online/PersonalCenter获取用户个人信息
export function getUserInfo() {
    return request({
        url: "/pc/check/online/PersonalCenter",
        method: "get",
    });
}